import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { TagsUpgradeModal } from '~publish/legacy/modals/components/TagsUpgradeModal/TagsUpgradeModal'
import { CanvaOriginalPostClosedModal } from '~publish/legacy/canva/CanvaOriginalPostClosedModal'
import { useCanvaLoader } from '~publish/legacy/canva/useCanvaLoader'
import { FirstCommentPaywallModal } from '~publish/legacy/composer/composer/components/first-comment-paywall-modal/FirstCommentPaywallModal'
import ProfilesDisconnectedModal from '~publish/legacy/profiles-disconnected-modal'
import { createPage } from '~publish/legacy/routes'
import type { RootState } from '~publish/legacy/store'

import TrialCollaborationModal from '../../../trial-collaboration-modal'
import { ConnectAChannelModal } from '../ConnectAChannelModal'

import type { JSX } from 'react'

const AppModals = (): JSX.Element => {
  const {
    showProfilesDisconnectedModal,
    showFirstCommentPaywallModal,
    showTrialCollaborationModal,
    showTagsLimitUpgradeModal,
    firstCommentPaywallService,
    showConnectAChannelModal,
    serviceToConnect,
  } = useSelector((state: RootState) => state.modals)
  const location = useLocation()
  const { showCanvaOriginalPostClosedModal } = useCanvaLoader()
  const isContentPath = location.pathname.startsWith(createPage.route)

  return (
    <>
      {showProfilesDisconnectedModal && !isContentPath && (
        <ProfilesDisconnectedModal />
      )}
      {showFirstCommentPaywallModal && (
        <FirstCommentPaywallModal service={firstCommentPaywallService} />
      )}
      {showCanvaOriginalPostClosedModal && <CanvaOriginalPostClosedModal />}
      {showTrialCollaborationModal && <TrialCollaborationModal />}
      {showTagsLimitUpgradeModal && <TagsUpgradeModal />}
      {showConnectAChannelModal && serviceToConnect && (
        <ConnectAChannelModal service={serviceToConnect} />
      )}
    </>
  )
}

export default AppModals
